import { render, staticRenderFns } from "./RiskJobTable.vue?vue&type=template&id=a5861e36"
import script from "./RiskJobTable.vue?vue&type=script&lang=js"
export * from "./RiskJobTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports